/// <amd-module name="Test/TestFlaky/Store/TestFlakyStore" />
import { ITestRunTestCaseResultHolder, TestFlakyActionHub } from "Actions/TestFlakyActionHub";
import { TestOutcomeEnum } from "Test/common-util/Common";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import * as Resources from "Test/TestFlaky/Resources";
import * as Util_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { Store } from "VSS/Reflux/Store";

export interface ITestRunDetails {
    BranchName: string;
}

export interface ITestResultDetails {
    computerName: string;
    testCaseTitle: string;
    container: string;
    outcome: TCMContracts.TestOutcome;
    testCaseRefId: number;
    startedDate: Date;
    completedDate: Date;
    state: string;
}

export interface ITestFlakyState {
    loading: boolean;
    showDialog: boolean;
    isPRBuild: boolean;
    testResults: ITestResultDetails;
    testRun: ITestRunDetails;
    errorMessage?: string;
}

export class TestFlakyStore extends Store {
    private _state: ITestFlakyState;

    constructor(private _pageContext: IVssPageContext, private _actionHub: TestFlakyActionHub, private _isTestResultFlaky: boolean) {
        super("");
        this._state = this._getInitialState();
        this._actionHub.updateFlakyDialog.addListener(this._updateFlakyDialogContent);
        this._actionHub.onDismiss.addListener(this._onDismiss);
        this._actionHub.onError.addListener(this._onError);
    }

    public dispose(): void {
        this._actionHub.onDismiss.removeListener(this._onDismiss);
        this._actionHub.onError.removeListener(this._onError);
        this._actionHub.updateFlakyDialog.removeListener(this._updateFlakyDialogContent);
    }

    public getState(): ITestFlakyState {
        return this._state;
    }

    private _getInitialState() {
        return {
            loading: true,
            showDialog: true,
            isPRBuild: false
        } as ITestFlakyState;
    }

    private _updateFlakyDialogContent = (data: ITestRunTestCaseResultHolder) => {
        if (!!data) {
            this._state.loading = false;
            this._state.showDialog = true;
            if (data.testCaseResult) {
                this._state.testResults = {
                    computerName: data.testCaseResult.computerName ? data.testCaseResult.computerName : "",
                    container: data.testCaseResult.automatedTestStorage ? data.testCaseResult.automatedTestStorage : Resources.Unspecified,
                    testCaseRefId: data.testCaseResult.testCaseReferenceId,
                    testCaseTitle: data.testCaseResult.testCaseTitle,
                    outcome: (TestOutcomeEnum as any)[data.testCaseResult.outcome],
                    state: data.testCaseResult.state,
                    startedDate: data.testCaseResult.startedDate,
                    completedDate: data.testCaseResult.completedDate
                };
            }

            if (data.testRun && data.testRun.buildConfiguration) {
                if (data.testRun.buildConfiguration.targetBranchName && data.testRun.buildConfiguration.targetBranchName !== "") {
                    this._state.isPRBuild = true;
                }

                this._state.testRun = {
                    BranchName: this._state.isPRBuild ? data.testRun.buildConfiguration.targetBranchName : data.testRun.buildConfiguration.branchName
                };
            } else {
                this._state.errorMessage = Resources.NoBranchInfoAvailable;
            }

            if (!this._state.errorMessage) {
                if (data.flakyIdentifiers) {
                    let alreadyMarkedOrUnMarked = false;
                    data.flakyIdentifiers.forEach((flakyIdentifier: TCMContracts.TestFlakyIdentifier) => {
                        if (
                            this._isTestResultFlaky !== flakyIdentifier.isFlaky &&
                            this._state.testRun &&
                            this._state.testRun.BranchName == flakyIdentifier.branchName
                        ) {
                            alreadyMarkedOrUnMarked = true;
                        }
                    });

                    if (alreadyMarkedOrUnMarked) {
                        this._state.errorMessage = Util_String.localeFormat(
                            this._isTestResultFlaky ? Resources.AlreadyUnMarkedFlakyMessage : Resources.AlreadyMarkedFlakyMessage
                        );
                    }
                } else {
                    if (this._isTestResultFlaky) {
                        this._state.errorMessage = Util_String.localeFormat(Resources.AlreadyUnMarkedFlakyMessage);
                    }
                }
            }

            this.emitChanged();
        }
    };

    private _onDismiss = () => {
        this._state.showDialog = false;

        this.emitChanged();
    };

    private _onError = (error: string) => {
        this._state.loading = false;
        this._state.errorMessage = error;

        this.emitChanged();
    };
}
